import { NavSection } from '@/components/nav-section'
import { NavUser } from '@/components/nav-user'
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
	SidebarTrigger,
} from '@/components/ui/sidebar'
import { WorkspaceSwitcher } from '@/components/workspace-switcher'
import { HoneyGridIcon } from '@/icons/HoneyGridIcon/HoneyGridIcon'
import { useStytchMember } from '@stytch/react/b2b'
import { Cable, FolderArchive, MapPin, Settings } from 'lucide-react'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import { WorkspaceSelector } from './WorkspaceSelector'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const { workspaceId = '' } = useParams()
	const { member } = useStytchMember()

	const platformMenuItems = [
		{
			title: 'Grids',
			url: `/${workspaceId}/grids`,
			icon: HoneyGridIcon,
		},
		{
			title: 'Locations',
			url: `/${workspaceId}/locations`,
			icon: MapPin,
		},
	]

	const settingsMenuItems = [
		{
			title: 'Connections',
			url: `/${workspaceId}/connections`,
			icon: Cable,
		},
		{
			title: 'Data Sources',
			url: `/${workspaceId}/data-sources`,
			icon: FolderArchive,
		},
		{
			title: 'Workspace Settings',
			url: `/${workspaceId}/settings/general`,
			icon: Settings,
			matchPattern: `/${workspaceId}/settings/.*`,
		},
	]

	// Transform Stytch member data to match the expected format
	const user = member
		? {
				name: member.name || member.email_address,
				email: member.email_address,
				avatar: '/avatars/default.jpg', // Use a default avatar for now
			}
		: {
				name: 'Loading...',
				email: '',
				avatar: '/avatars/default.jpg',
			}

	return (
		<>
			<Sidebar collapsible="icon" {...props}>
				<SidebarHeader>
					<SidebarTrigger className="size-8" />
					<WorkspaceSwitcher />
				</SidebarHeader>
				<SidebarContent>
					<NavSection title="Platform" items={platformMenuItems} />
					<NavSection title="Settings" items={settingsMenuItems} />
				</SidebarContent>
				<SidebarFooter>
					<NavUser user={user} />
				</SidebarFooter>
				<SidebarRail />
			</Sidebar>
			<WorkspaceSelector />
		</>
	)
}
